<template>
  <FKBreadCrumb :page="consent.current_version?.revision_number ?? $t('page.policies')"  :title="consent.current_version?.title ?? $t('page.policies')">
    <FKBreadCrumbItem :page="$t('page.policies')" :to="'/profile/policies'"></FKBreadCrumbItem>
  </FKBreadCrumb>
  <PoliciesDetail />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import PoliciesDetail from "@/components/FK/Profile/Policies/PoliciesDetail.vue";
import { Consent } from "@/utils/models/consent.model";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";

export default defineComponent({
  name: "PoliciesPage",
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    PoliciesDetail
  },
  data() {
        return {
            consent: this.$route.meta.consent as Consent,
        }
    },

});
</script>